import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { whiteListNumeric, whiteListRegex, whiteListRegexOnlyLettersAndCertainChars } from '../../utils/StringUtils';
export var CCFIELDS = /*#__PURE__*/function (CCFIELDS) {
  CCFIELDS["CARDHOLDER_NAME"] = "cardholderName";
  CCFIELDS["BILLING_ZIP"] = "zip";
  CCFIELDS["BILLING_ZIP_UPI"] = "zip_upi";
  CCFIELDS["CARD_NUMBER"] = "number";
  CCFIELDS["EXPIRATION_DATE"] = "expirationDate";
  CCFIELDS["CVV"] = "cvv";
  CCFIELDS["EXPIRATION_MONTH"] = "expirationMonth";
  CCFIELDS["EXPIRATION_YEAR"] = "expirationYear";
  return CCFIELDS;
}({});

// different types of validations that exist. (note: only REQUIRED is implemented so far)
export var VALIDATION_TYPES = /*#__PURE__*/function (VALIDATION_TYPES) {
  VALIDATION_TYPES["REQUIRED"] = "required";
  VALIDATION_TYPES["NUMERIC"] = "numeric";
  VALIDATION_TYPES["NUMERIC_UPI"] = "numeric_upi";
  VALIDATION_TYPES["ALPHA"] = "alpha";
  VALIDATION_TYPES["ALPHANUMERIC"] = "alphanumeric";
  VALIDATION_TYPES["MIN_LENGTH"] = "minimumLength";
  VALIDATION_TYPES["REQUIRED_UPI"] = "required_upi";
  VALIDATION_TYPES["LENGTH_UPI"] = "length_upi";
  VALIDATION_TYPES["INVALID"] = "invalid";
  VALIDATION_TYPES["ONLYLETTERSANDCERTAINCHARS"] = "onlyLettersAndCertainChars";
  return VALIDATION_TYPES;
}({});

// mapping of all validations to be performed on a field.  If the field
// does not have any validations on it, then
var FIELD_VALIDATION_MAP = _defineProperty(_defineProperty(_defineProperty({}, CCFIELDS.CARDHOLDER_NAME, [VALIDATION_TYPES.REQUIRED, VALIDATION_TYPES.ONLYLETTERSANDCERTAINCHARS]), CCFIELDS.BILLING_ZIP, [VALIDATION_TYPES.REQUIRED]), CCFIELDS.BILLING_ZIP_UPI, [VALIDATION_TYPES.REQUIRED_UPI, VALIDATION_TYPES.NUMERIC_UPI, VALIDATION_TYPES.LENGTH_UPI]);
var isValid = function isValid(value, validationType, length) {
  var isRequiredValid = false;
  if (validationType === VALIDATION_TYPES.REQUIRED || validationType === VALIDATION_TYPES.REQUIRED_UPI) {
    isRequiredValid = ValidationHelper.testRequired(value);

    // return false right away if field is required
    if (!isRequiredValid) {
      return false;
    }
  }
  if (validationType === VALIDATION_TYPES.ALPHANUMERIC) {
    if (ValidationHelper.checkInvalidCharacters(value)) {
      return false;
    }
  }
  if (validationType === VALIDATION_TYPES.ONLYLETTERSANDCERTAINCHARS) {
    if (ValidationHelper.checkForOnlyLettersAndCertainChars(value)) {
      return false;
    }
  }
  if (validationType === VALIDATION_TYPES.NUMERIC_UPI) {
    return ValidationHelper.checkForNumeric(value);
  }
  if (validationType === VALIDATION_TYPES.LENGTH_UPI) {
    return ValidationHelper.checkForLength(value, length);
  }
  return true;
};

// Validation logic for testing REQUIRED field
var testRequired = function testRequired(value) {
  return value.length > 0;
};

/**
 * checks if value contains only letters and certain allowed characters
 * @param {string} value
 * @returns {boolean}
 */
export var checkForOnlyLettersAndCertainChars = function checkForOnlyLettersAndCertainChars(value) {
  return !!value.match(whiteListRegexOnlyLettersAndCertainChars);
};

/**
 * checks if value contains invalid characters
 * @param {string} value
 * @returns {boolean}
 */
export var checkInvalidCharacters = function checkInvalidCharacters(value) {
  return !!value.match(whiteListRegex);
};

/**
 * checks if value consists of numeric characters only
 * @param {string} value
 * @returns {boolean}
 */
export var checkForNumeric = function checkForNumeric(value) {
  return !!value.match(whiteListNumeric);
};

/**
 * checks if length of value matches the given length
 * @param {string} value
 * @param {number} length optional
 * @returns {boolean}
 */
export var checkForLength = function checkForLength(value, length) {
  if (!length) return true;
  return value.length === length;
};
export var ValidationHelper = {
  CCFIELDS: CCFIELDS,
  VALIDATION_TYPES: VALIDATION_TYPES,
  // do not use this for type definition.  instead, import VALIDATION_TYPES directly
  FIELD_VALIDATION_MAP: FIELD_VALIDATION_MAP,
  isValid: isValid,
  testRequired: testRequired,
  checkForOnlyLettersAndCertainChars: checkForOnlyLettersAndCertainChars,
  checkInvalidCharacters: checkInvalidCharacters,
  checkForNumeric: checkForNumeric,
  checkForLength: checkForLength
};
export default ValidationHelper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/business/validators/ValidationHelper.js
// module id = 839
// module chunks = 11